import type { ReactNode } from "react";

import { cn } from "@flare/ui";

export function StepContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex min-h-[calc(-65px+100svh)] flex-col justify-between bg-white-80 pt-6 md:min-h-[calc(-73px+100svh)] md:pt-8",
        className,
      )}
    >
      {children}
    </div>
  );
}
